import React, { FC }        from 'react';
import {
    useLocation
}                           from 'react-router-dom';
import {
    Credentials
}                           from "@aws-sdk/client-sts";
import {
    S3Client,
    GetObjectCommand
}                           from "@aws-sdk/client-s3";

import getApiPromise        from 'utils/getApiPromise';

import * as MenuItem        from 'components/MenuItem';
import tectransit           from 'utils/TecTransit';

interface Props {
}
const Photo : FC<Props> = props => {

    const locationState     = useLocation().state as {
        title   : string;
        key     : string;
    };
    const [errMessage,setErrMessage]    = React.useState<string>('');
    const [photoObject,setPhotoObject]  = React.useState<Blob|undefined>();

    React.useEffect(() => {
        if( !tectransit.agency.s3_bucket_name ) {
            setErrMessage(`S3 bucket not configured`);
            return;
        }
        getApiPromise<Credentials>('/api/passenger/s3Credentials','GET')
            .then( credentials => {
                if( !credentials || credentials.err )
                    throw Error(credentials?.err||`credentials are empty`);
                const s3Client = new S3Client({
                    region     : tectransit.agency.s3_region,
                    credentials: {
                        accessKeyId     : credentials.AccessKeyId!,
                        secretAccessKey : credentials.SecretAccessKey!,
                        sessionToken    : credentials.SessionToken
                    }
                });
                s3Client.send(new GetObjectCommand({
                    Bucket  : tectransit.agency.s3_bucket_name,
                    Key     : locationState.key
                })).then( getObjectOutput => {
                    if( !getObjectOutput.Body )
                        throw Error(`no body in getObjectOutput`);
                    return getObjectOutput.Body.transformToWebStream();
                }).then( str => {
                    return new Response(str).blob();
                }).then( blob => {
                    setPhotoObject(blob);
                })
                .catch( err => {
                    setErrMessage(`Cannot get object '${locationState.key}' (${err.message})`);
                });
            })
            .catch( err => {
                setErrMessage(`Cannot get credentials (${err.message})`);
            });
    },[locationState.key]);

    return MenuItem.withMenuItem(locationState.title, (alert) => {
        if( errMessage ) {
            alert.set(errMessage);
            return false;
        }
        if( !photoObject )
            return (<div>Loading...</div>);
        return (
            <img
                alt="user dvi"
                src={URL.createObjectURL(photoObject)}
                style={{display:'block',margin:'auto',width:'50%'}}
            />
        );
    });
}

export default Photo;
